import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'home',
        children: [
          {
            path: '',
            loadChildren: '../tab-home/tab-home.module#TabHomePageModule'
          },
          {
            path: 'web',
            loadChildren: '../page-public/website/website.module#WebsitePageModule'
          },
          {
            path: 'students',
            loadChildren: '../page-public/students/students.module#StudentsPageModule'
          },
          {
            path: 'teachers',
            loadChildren: '../page-public/teachers/teachers.module#TeachersPageModule'
          },
          {
            path: 'ekskul',
            loadChildren: '../page-public/ekskul/ekskul.module#EkskulPageModule'
          },          
          {
            path: 'prestasi',
            loadChildren: '../page-public/prestasi/prestasi.module#PrestasiPageModule'
          },
          {
            path: 'form',
            loadChildren: '../page-public/form/form.module#FormPageModule'
          },
          {
            path: 'calendar',
            loadChildren: '../page-public/calendar/calendar.module#CalendarPageModule'
          },
          {
            path: 'eksis',
            loadChildren: '../page-public/eksis/eksis.module#EksisPageModule'
          },
          {
            path: 'eksis/:tag',
            loadChildren: '../page-public/eksis-kategori/eksis-kategori.module#EksisKategoriPageModule'
          },
          {
            path: 'buat-posting',
            loadChildren: '../page-public/buat-posting/buat-posting.module#BuatPostingPageModule'
          },
         
        ]
      },
      {
        path: 'member',
        children: [
          {
            path: '',
            loadChildren: '../tab-member/tab-member.module#TabMemberPageModule'
          },
          {
            path: 'parent',
            loadChildren: '../tab-member/parent/member-parent/member-parent.module#MemberParentPageModule'
          },
          {
            path: 'teacher',
            loadChildren: '../tab-member/teacher/member-teacher/member-teacher.module#MemberTeacherPageModule'
          },
          //parent area
          {
            path: 'parent/nilai',
            loadChildren: '../tab-member/parent/nilai-siswa/nilai-siswa.module#NilaiSiswaPageModule'
          },
          {
            path: 'parent/presensi',
            loadChildren: '../tab-member/parent/presensi/presensi.module#PresensiPageModule'
          },
          {
            path: 'parent/ekskul-siswa',
            loadChildren: '../tab-member/parent/ekskul-siswa/ekskul-siswa.module#EkskulSiswaPageModule'
          },
          //tacher area
          {
            path: 'teacher/detail-classroom/:id',
            loadChildren: '../tab-member/teacher/detail-classroom/detail-classroom.module#DetailClassroomPageModule'
          },
          {
            path: 'teacher/input-nilai-ekskul/:id',
            loadChildren: '../tab-member/teacher/input-nilai-ekskul/input-nilai-ekskul.module#InputNilaiEkskulPageModule'
          },
          {
            path: 'teacher/ekskul-setting/:id',
            loadChildren: '../tab-member/teacher/ekskul-setting/ekskul-setting.module#EkskulSettingPageModule'
          },
        ]
      },
      {
        path: 'inbox',
        children: [
          {
            path: '',
            loadChildren: '../tab-inbox/tab-inbox.module#TabInboxPageModule'
          }
        ]
      },
      {
        path: 'account',
        children: [
          {
            path: '',
            loadChildren: '../tab-account/tab-account.module#TabAccountPageModule'
          }
        ]
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class TabsPageRoutingModule {}
